import { ApiClient } from '@/infra/api-client'

export class AgentsEnablementApi extends ApiClient {
  getStatus(
    workspaceId: string,
    signal?: AbortSignal,
  ): Promise<{ enabled: boolean }> {
    return this._get(
      `api/v1/workspace-agents-settings/${encodeURIComponent(
        workspaceId,
      )}/status`,
      undefined,
      { signal },
    )
  }
}
